import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import * as React from 'react';
import { initISODate } from '~logic/helpers/initISODate';
import { useStorage } from '../../../contexts/StorageContext/StorageProvider';
import { usePersistenceScope } from './usePersistenceScope';

/**
 * Encapsulates storage operations.
 * Provides handlers for storing, retrieving and removing items
 * that are set under the given `key`.
 *
 * @returns tuple of `[getData, setData, removeData]` handlers
 */
export var usePersistence = function usePersistence(_ref) {
  var key = _ref.key;
  var storage = useStorage();
  var refKey = React.useRef(key);
  var scopeKey = usePersistenceScope(); // query the persistence & return the value

  var getStoredValue = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var storedValue, restoredValue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return storage.getItem(scopeKey(refKey.current));

          case 2:
            storedValue = _context.sent;
            restoredValue = storedValue ? JSON.parse(storedValue, initISODate) : null;
            return _context.abrupt("return", restoredValue);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [scopeKey, storage]); // save the value into the storage

  var setStoreValue = React.useCallback(function (value) {
    var stringifiedValue = JSON.stringify(value);
    storage.setItem(scopeKey(refKey.current), stringifiedValue);
  }, [scopeKey, storage]); // remove the stored item from the persistence

  var removeStoredValue = React.useCallback(function () {
    storage.removeItem(scopeKey(refKey.current));
  }, [scopeKey, storage]);
  return [getStoredValue, setStoreValue, removeStoredValue];
};